import React from "react";
import Hero from "../components/marketing/Hero";
import Stats from "../components/marketing/Stats";
import AboutPreview from "../components/marketing/AboutPreview";
import CoursesGrid from "../components/marketing/CoursesGrid";
import Gallery from "../components/marketing/Gallery";
import Testimonials from "../components/marketing/Testimonials";
import ContactCTA from "../components/marketing/ContactCTA";
import EditorialMarquee from "../components/marketing/Marquee";
import { useContent } from "../context/ContentContext";

export default function Home() {
  const { settings, courses, gallery, testimonials } = useContent();
  return (
    <div data-testid="home-page">
      <Hero settings={settings} />
      <Stats settings={settings} />
      <AboutPreview />
      <EditorialMarquee />
      <CoursesGrid courses={courses} limit={5} />
      <Gallery items={gallery} preview />
      <Testimonials items={testimonials} />
      <ContactCTA />
    </div>
  );
}
